import { LinkType } from '../Link';
import {
  INTERNATIONAL_PHONE_NUMBER_REGEX,
  NORTH_AMERICAN_PHONE_NUMBER_REGEX,
} from './constants';

const removeNonDigits = (phoneNumber: string) => phoneNumber.replace(/\D/g, '');

const formatURL = (url: string) => {
  if (url.toLowerCase().indexOf(':') === -1) {
    return `http://${url}`;
  } else {
    return url;
  }
};

export const formatPhoneNumberForLink = (phoneNumber: string) => {
  if (!phoneNumber) {
    return phoneNumber;
  }

  const cleanedPhoneNumber = removeNonDigits(phoneNumber);
  if (cleanedPhoneNumber.length >= 11) {
    return `+${cleanedPhoneNumber}`;
  }

  return cleanedPhoneNumber;
};

export const formatPhoneNumberForDisplay = (phoneNumber: string) => {
  if (!phoneNumber) {
    return phoneNumber;
  }

  const cleanedPhoneNumber = removeNonDigits(phoneNumber);

  let match = cleanedPhoneNumber.match(NORTH_AMERICAN_PHONE_NUMBER_REGEX);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }

  match = cleanedPhoneNumber.match(INTERNATIONAL_PHONE_NUMBER_REGEX);
  if (match) {
    return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}`;
  }

  return phoneNumber;
};

export const getDisplayValue = (value: string, type: LinkType | undefined) => {
  switch (type) {
    case 'tel':
      return formatPhoneNumberForDisplay(value);
    default:
      return value;
  }
};

export const getPath = (
  value: string,
  type: LinkType | undefined,
  path?: string | undefined
) => {
  switch (type) {
    case 'tel':
      return `tel:${formatPhoneNumberForLink(value)}`;
    case 'email':
      return `mailto:${value}`;
    case 'url':
      return `${formatURL(value)}`;
    default:
      return path ?? '';
  }
};
